import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import AdminActionsPopupNew from "../../admin-actions-popup/AdminActionsPopupNew";
import { connect } from "react-redux";
import {
  addSelectedUser,
  deleteSelectedUser,
} from "../../../../../redux/users/users-actions";
import { createStructuredSelector } from "reselect";
import { selectSelectedUsers } from "../../../../../redux/users/users-selector";
import "./user-row.styles.scss";

const UserRowNew = ({
  user,
  privileges,
  profile,
  addSelectedUser,
  deleteSelectedUser,
  selectedUsers,
  onArchiveSuccess
}) => {
  const [showAdminActionsPopup, setShowAdminActionsPopup] = useState(false);
  const isCurrentUser = user?.Id === profile?.userID;
  const canEdit = privileges?.User?.Edit;
  const canArchive = privileges?.User?.Delete && !isCurrentUser;
  let history = useHistory();

  const onEdit = () => {
    if (canEdit) history.push(`/admin/users/edit/${user.Id}`);
  };

  const onArchive = () => {
    if (canArchive) setShowAdminActionsPopup(true);
  };

  const onSelect = (e) => {
    if (e.target.checked) {
      addSelectedUser(user.Id);
    } else {
      deleteSelectedUser(user.Id);
    }
  };

  return (
    <tr className="user-row-1">
      <td className="th-checkbox-col">
        <Form.Check
          type={"checkbox"}
          disabled={!canArchive}
          onClick={(e) => {
            onSelect(e);
          }}
          checked={selectedUsers.includes(user.Id)}
        />
      </td>
      <td className="data-text user-name">{user.Name}</td>
      <td className="data-text user-email">{user.Email}</td>
      <td className="data-text user-company">{user.CompanyName}</td>
      <td className="data-text user-role">{user.StrRole}</td>
      <td className="admin-row-status user-status">
        {user.Active ? (
          <div className="status active">Active</div>
        ) : (
          <div className="status inactive">Inactive</div>
        )}
      </td>
      <td className="admin-row-action-buttons user-actions">
        <Button
          disabled={!canArchive}
          className={`btn-icon1 archive-icon1${!canArchive ? "-disabled" : ""}`}
          onClick={() => onArchive()}
          title="Archive"
        />
        <Button
          disabled={!canEdit}
          className={`btn-icon1 edit-icon1${!canEdit ? "-disabled" : ""}`}
          onClick={() => onEdit()}
          title="Edit"
        />
      </td>
      {showAdminActionsPopup && (
        <AdminActionsPopupNew
          type={"user"}
          name={user.Name}
          selectedIDs={[user.Id]}
          showAdminActionsPopup={showAdminActionsPopup}
          setShowAdminActionsPopup={setShowAdminActionsPopup}
          onArchiveSuccess={onArchiveSuccess}
        />
      )}
    </tr>
  );
};

const mapState = createStructuredSelector({
  selectedUsers: selectSelectedUsers,
});

const mapDispatch = (dispatch) => ({
  addSelectedUser: (userId) => dispatch(addSelectedUser(userId)),
  deleteSelectedUser: (userId) => dispatch(deleteSelectedUser(userId)),
});

UserRowNew.propTypes = {
  user: PropTypes.object.isRequired,
  privileges: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  addSelectedUser: PropTypes.func.isRequired,
  deleteSelectedUser: PropTypes.func.isRequired,
  selectedUsers: PropTypes.array.isRequired,
  handleArchiveSuccess: PropTypes.func.isRequired,
};
export default connect(mapState, mapDispatch)(UserRowNew);
